import React, { useEffect, useState } from "react";
import api from "~/services/api";
import CreateEditContent from "./CreateEditContent";
import { LandPage, Container, Main } from './styles';
import { Colors } from "~/config/Colors";
import {
  SLEditModal,
  SLCreateModal,
} from "~/pages/Sistema/componentes/SistemaList";
import { useSelector } from "react-redux";
import TableComponent from "./TableComponent";

export default function Pesquisas() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    async function handleRequests() {
      api
        .get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));
    }

    handleRequests();
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: () =>
                api.get('/signed/cliente/pesquisa/gerenciamento/pesquisas'),
              findOne: thisData =>
                api.get('/signed/cliente/pesquisa/gerenciamento/pesquisa', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/cliente/pesquisa/gerenciamento/pesquisa', {
                  data: { id: thisData.id },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Pesquisas',
              subTitle: "Adiocione as Pesquisas",
              icone: 'submenu-pesquisa',
            }}
            tabFilter={{
              initial: { ativo: true },
              tabAtivo: 0,
              list: [
                {
                  corDestaque: Colors?.Color4,
                  corFundo: Colors?.Color8,
                  title: 'Ativo',
                  value: { ativo: true },
                },
                {
                  corDestaque: localStorage.getItem("tema") == "E" ? '#9A3636' : '#e68282',
                  corFundo: Colors?.Color8,
                  title: 'Desativado',
                  value: { ativo: false },
                },
              ],
            }}
            pageSize={6}
            inputs={[
              { filter: 'titulo', label: 'Titulo' },
              { filter: 'codigoDevice', label: 'Device' },
            ]}
          >
            <SLEditModal title="Atualizar Pesquisa" setter={setMountedData}>
              {mountedData && modulos && (
                <CreateEditContent {...{ modulos, mountedData }} />
              )}
            </SLEditModal>

            <SLCreateModal title="Adicionar Pesquisa">
              {modulos && <CreateEditContent {...{ modulos }} />}
            </SLCreateModal>

            <TableComponent />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
